import { Injectable, OnDestroy } from '@angular/core';
import {
  OMVIZ_COMPONENTS,
  OmvizService,
  RELOAD_ERROR,
  TOKEN_ERROR,
  defaultQlikConfig,
  intQlikConfig,
  myrecQlikConfig,
} from 'omviz';
import { OmvizQlikConfig } from 'omviz/lib/models';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { QlikConfig } from 'src/environments/environment.interface';

import { AuthService } from 'src/app/shared/api-ux/authentication.service';
import configuration from '../../../assets/reports/configuration.json';

@Injectable({
  providedIn: 'root',
})
export class OmvizWrapperService implements OnDestroy {
  private onDestroy$ = new ReplaySubject<void>(null);

  constructor(private omviz: OmvizService) {}

  init() {
    switch (environment.qlikConfig) {
      case QlikConfig.Default:
        let config: OmvizQlikConfig = {
          secure: true,

          host: '172.16.1.47',

          port: 443,

          prefix: 'jwt-test',

          componentsConfigUrl: 'https://172.16.1.47/jwt-test/content/omviz/components-config.json',
        };
        this.omviz.setQlikConfig(config);
        break;
      case QlikConfig.Integration:
        this.omviz.setQlikConfig(intQlikConfig);
        console.log('Qlik config: INT', intQlikConfig);
        break;
      case QlikConfig.Recette:
        this.omviz.setQlikConfig(myrecQlikConfig);
        console.log('Qlik config: REC', myrecQlikConfig);
        break;
      case QlikConfig.Production:
        this.omviz.setQlikConfig(defaultQlikConfig);
        break;
      default:
        throw `Unknown Qlik configuration ${environment.qlikConfig}`;
    }

    this.omviz.setLoggerLevel('trace');
    this.omviz
      .getObservable()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        () => {},
        err => {
          this.setOmvizToken();
          if (err === TOKEN_ERROR) {
            console.log('Qlik: Token error');
            this.setOmvizToken();
          } else if (err === RELOAD_ERROR) {
            console.log('Qlik: Reload error');
            window.location.reload();
          } else {
            console.log('Qlik: Unknown error', JSON.stringify(err));
          }
        }
      );
    this.setOmvizToken();
  }

  private setOmvizToken() {
    const authToken = sessionStorage.getItem(AuthService.TOKEN_KEY);
    this.omviz.setToken(authToken);
  }

  public getOmvizReport(id: string) {
    var result = Object.keys(OMVIZ_COMPONENTS)
      .map(k => OMVIZ_COMPONENTS[k])
      .find(r => r.id === id);

    if (!result) {
      console.error(`Composant Omviz inconnu: ${id}`);
    }

    return result;
  }

  public clearSelections() {
    return this.omviz.clearSelections();
  }

  getSizeClass(reportId: string) {
    const conf = configuration.configuration.find(c => c.id === reportId);
    let size;
    if (!conf) {
      size = 1;
    } else {
      size = conf.size;
    }
    switch (size) {
      case 0:
        return 'hidden';
      case 1:
        return 'col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-3';
      case 2:
        return 'col-xs-12 col-sm-6 col-md-8 col-lg-8 col-xl-6';
      case 3:
        return 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-9';
      case 4:
        return 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12';
      default:
        throw `Unknown size ${size} for report ${reportId}`;
    }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
